module.exports = __webpack_public_path__ + "img/essentials.b589aca.webp";